import { userService } from '@saucelabs/sl-util-axios';

export const fetchUsers = ({ limit = 99999, offset = 0, phrase } = {}) => (
  userService.get('/v1/users/', { params: { limit, offset, phrase } })
);

export const fetchTeams = ({ limit = 99999, offset = 0, name } = {}) => (
  userService.get('/v1/teams/', { params: { limit, offset, name } })
);

export const fetchUser = ({ id }) => (
  userService.get(`/v1/users/${id}`)
);
